module.exports = __webpack_public_path__ + "static/media/textpage2.c448eb07.png";